import { MouseEvent, useCallback } from 'react';
import { RouteType } from 'b2b-apps/shop/routes/components/Router';
import { useOpenLink, useUrlCreator } from 'b2b-apps/shop/routes/hooks';

type UseRouteLinkReturnType = {
  handleClick: (params?: Record<string, any>) => OnAnchorClickType;
  href: (params?: Record<string, any>) => string;
};

const useRouteLink = (route: RouteType): UseRouteLinkReturnType => {
  const openLink = useOpenLink();
  const urlCreator = useUrlCreator();
  const href = useCallback(
    (params?: Record<string, any>) => urlCreator(route, params),
    [route, urlCreator],
  );

  const handleClick = useCallback(
    (params?: Record<string, any>): OnAnchorClickType => (
      e: MouseEvent<HTMLAnchorElement>,
    ): void => {
      e.preventDefault();
      openLink(e, href(params));
    },
    [href, openLink],
  );

  return {
    handleClick,
    href,
  };
};

export { useRouteLink };
export type { UseRouteLinkReturnType };
